export default {
    DEFAULT_WEEKS_MAP: {
        '1': true,
        '2': true,
        '3': true,
        '4': true,
        '5': true,
        '6': true,
        '7': true
    },
    DEFAULT_DAY: '2-15',
    DEFAULT_DAY_OBJ: {start: 2, end: 15},
    DEFAULT_DEP_CITY_LIST: [{
        name: '北京'
    }],
    EMPTY_CITY_LIST: [{}],
    FLIGHT_TYPE:{
        ONE_WAY: 1,
        ROUND_WAY: 2
    }

}